import React from 'react';
import { OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 rounded-xl border-b-4 border-black/25 bg-brand-orange px-4 py-3 text-center font-display text-[13px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-brand-orange/25 transition-all duration-200 hover:bg-brand-amber active:translate-y-1 active:border-b-0 sm:px-5 sm:text-base ${className}`} data-id="element-33" data-mp="2kzzfenzpr6rq">
      {children}
    </a>;
}